import { useMemo } from 'react';
import { useAppSelector } from '@/shared/model';
import type { PresetViewType } from '../api/types';
import { filterPresetsByViewType } from '../libs/filterPresetsByViewType';
import { selectPresets } from './slice';
import type { SavedPresetRecord, Validator } from './types';

export function usePresetsForViewType<T>(
  viewType: PresetViewType,
  validator: Validator,
): SavedPresetRecord<T>[] {
  const allPresets = useAppSelector(selectPresets);
  return useMemo(() => {
    return filterPresetsByViewType(allPresets, viewType, validator).sort(
      (a, b) => {
        if (a.isFavorite !== b.isFavorite) {
          return a.isFavorite ? -1 : 1;
        }

        return (
          new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime()
        );
      },
    ) as SavedPresetRecord<T>[];
  }, [allPresets, viewType, validator]);
}
